import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './i18n/en/translation.json';
import translationES from './i18n/es/translation.json';
import translationAR from './i18n/ar/translation.json';
import translationDE from './i18n/de/translation.json';
import translationFR from './i18n/fr/translation.json';
import translationIT from './i18n/it/translation.json';
import translationRU from './i18n/ru/translation.json';
import translationPT from './i18n/pt/translation.json';
const resources = {
  en: { translation: translationEN },
  es: { translation: translationES },
  ar: { translation: translationAR },
  de: { translation: translationDE },
  fr: { translation: translationFR },
  it: { translation: translationIT },
  ru: { translation: translationRU },
  pt: { translation: translationPT },
};

i18n
  .use(LanguageDetector) // detecta el idioma del navegador
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;